import { create } from 'zustand'

/**
 * Счётчик открытых фуллскрин-оверлеев (SkinShowcaseModal и т.п.).
 * Пока overlayCount > 0, мелкий хром поверх страницы (кнопка прокрутки наверх
 * в ScrollToTop) должен прятаться: оверлеи рендерятся внутри анимированных
 * контейнеров со своим stacking context, и z-index не спасает от кнопок у корня.
 */
const useUiOverlayStore = create((set) => ({
  overlayCount: 0,
  pushOverlay: () => set((state) => ({ overlayCount: state.overlayCount + 1 })),
  popOverlay: () => set((state) => ({ overlayCount: Math.max(0, state.overlayCount - 1) }))
}))

export default useUiOverlayStore
